import GameSwitcher from './game-switcher';
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarGroup,
	SidebarGroupContent,
	SidebarGroupLabel,
	SidebarHeader,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from './ui/sidebar';

import { GameModules } from '@/configs/site-config';
import { useUser } from '@/hooks/use-user';
import { Project } from '@/state/use-admin';
import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

interface GameSidebarProps {
	projectId: number;
	gameId?: number;
}

const GameSidebar = ({ projectId, gameId }: GameSidebarProps) => {
	const navigate = useNavigate();
	const { data: user, isLoading, error } = useUser();

	const [project, setProject] = useState<Project | undefined>(undefined);

	// const [curGameId, setCurGameId] = useState<number | undefined>(gameId);

	const onSelectGame = useCallback(
		(gameId: number | undefined) => {
			if (gameId !== null && gameId !== undefined) {
				// setCurGameId(gameId);
				navigate(`/projects/${projectId}/${gameId}/character-query`);
			}
		},
		[projectId, navigate]
	);

	useEffect(() => {
		const project = user?.projects.find(p => p.id === projectId);
		setProject(project);

		const firstGameId = project?.games[0]?.id;
		if (gameId !== undefined && gameId !== null) {
			// const game = project?.games.find(g => g.id === gameId);
			// onSelectGame(game ? gameId : firstGameId);
		} else {
			onSelectGame(firstGameId);
		}
	}, [user, projectId, gameId, onSelectGame]);

	if (isLoading) {
		return <div>Loading...</div>;
	}

	if (error) {
		console.error(error);
		navigate('/login');
	}

	return (
		<Sidebar variant="sidebar" className="top-16">
			<SidebarHeader>
				{project?.games &&
					project.games?.length > 0 &&
					gameId !== null &&
					gameId !== undefined && (
						<GameSwitcher
							project={project}
							selectedGameId={gameId}
							onSelectGame={onSelectGame}
						/>
					)}
			</SidebarHeader>
			<SidebarContent>
				<SidebarGroup>
					<SidebarGroupLabel>Applications</SidebarGroupLabel>
					<SidebarGroupContent>
						<SidebarMenu>
							{gameId !== undefined &&
								gameId !== null &&
								GameModules.map(item => (
									<SidebarMenuItem key={item.title}>
										<SidebarMenuButton asChild>
											<Link to={`${gameId}/${item.href}`}>
												<item.icon />
												<span>{item.title}</span>
											</Link>
										</SidebarMenuButton>
									</SidebarMenuItem>
								))}
						</SidebarMenu>
					</SidebarGroupContent>
				</SidebarGroup>
			</SidebarContent>
			<SidebarFooter />
		</Sidebar>
	);
};

export default GameSidebar;

